import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  nullable1in0t8o94jx9t as nullable,
  presentmhd0a0ip21um as present,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  list2lpjhmv1d2k19 as list,
  obj2vqjd1bjrpmyg as obj,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance9mu49fvvgdlz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { AvatarType_ResponseAdapter_instance32ktucgjbbtjc as AvatarType_ResponseAdapter_instance } from './AvatarType_ResponseAdapter.mjs';
import { PinInput_InputAdapter_instance7qh971mvyfs7 as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from '../PinnedPlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInput_InputAdapterClass;
function PinnedPlayerInput_InputAdapter() {
  if (PinnedPlayerInput_InputAdapterClass === VOID) {
    class $ {
      q40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      e6s(writer, customScalarAdapters, value) {
        writer.t48('id');
        get_playerIdAdapter().r40(writer, customScalarAdapters, value.u6p_1);
        writer.t48('name');
        get_StringAdapter().r40(writer, customScalarAdapters, value.v6p_1);
        writer.t48('email');
        get_StringAdapter().r40(writer, customScalarAdapters, value.w6p_1);
        var tmp = value.x6p_1;
        if (tmp instanceof Present()) {
          writer.t48('badge');
          present(nullable(Badge_ResponseAdapter_instance)).a42(writer, customScalarAdapters, value.x6p_1);
        }
        writer.t48('callSignAdjective');
        get_StringAdapter().r40(writer, customScalarAdapters, value.y6p_1);
        writer.t48('callSignNoun');
        get_StringAdapter().r40(writer, customScalarAdapters, value.z6p_1);
        var tmp_0 = value.a6q_1;
        if (tmp_0 instanceof Present()) {
          writer.t48('imageURL');
          present(get_NullableStringAdapter()).a42(writer, customScalarAdapters, value.a6q_1);
        }
        var tmp_1 = value.b6q_1;
        if (tmp_1 instanceof Present()) {
          writer.t48('avatarType');
          present(nullable(AvatarType_ResponseAdapter_instance)).a42(writer, customScalarAdapters, value.b6q_1);
        }
        writer.t48('unvalidatedEmails');
        list(get_StringAdapter()).y41(writer, customScalarAdapters, value.c6q_1);
        writer.t48('pins');
        list(obj(PinInput_InputAdapter_instance)).y41(writer, customScalarAdapters, value.d6q_1);
      }
      r40(writer, customScalarAdapters, value) {
        return this.e6s(writer, customScalarAdapters, value instanceof PinnedPlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPlayerInput_InputAdapterClass = $;
  }
  return PinnedPlayerInput_InputAdapterClass;
}
var PinnedPlayerInput_InputAdapter_instance;
function PinnedPlayerInput_InputAdapter_getInstance() {
  return PinnedPlayerInput_InputAdapter_instance;
}
//region block: init
PinnedPlayerInput_InputAdapter_instance = new (PinnedPlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPlayerInput_InputAdapter_instance as PinnedPlayerInput_InputAdapter_instancesqyq5n185zzu,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput_InputAdapter.mjs.map
